import vSelect from 'vue-select'
import Loading from './components/Loading.vue'
import Pending from './components/Pending.vue'
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install (Vue) {
	Vue.component('loading', Loading)
  Vue.component('pending', Pending)
	Vue.component('v-select', vSelect)
  }
}

export default GlobalComponents



// WEBPACK FOOTER //
// ./src/globalComponents.js